<template>
  <div
    class="modal fade"
    :style="{ display: 'block' }"
    :class="'show'"
    @click="close"
    id="modalManager"
    tabindex="-1"
    aria-labelledby="modalManager"
    aria-hidden="true"
  >
    <div :class="dialogClass">
      <div class="modal-content" @click.stop>
        <slot></slot>
      </div>
    </div>
  </div>

  <div class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  name: "ui-modal",
  props: {
    close: Function,
    notification: Boolean,
    docSign: Boolean,
    // окно средней ширины (600px) — короткие формы в одну колонку
    medium: Boolean,
  },
  computed: {
    dialogClass() {
      if (this.notification)
        return "modal-dialog-notification modal-dialog-centered";
      if (this.docSign) return "modal-dialog-docSign modal-dialog-centered";
      if (this.medium)
        return "modal-dialog modal-dialog-centered modal-dialog-medium";
      return "modal-dialog modal-dialog-centered";
    },
  },
  beforeMount() {
    document.body.classList.add("modal-open");
    document.body.style.overflowY = "hidden";
  },
  beforeUnmount() {
    document.body.classList.remove("modal-open");
    document.body.style.overflowY = "auto";
  },
};
</script>